import { useMemo } from 'react';

import { buildImportCandidates } from './campaignScheduleImportCandidates';
import type { BrandSchedule, CampaignSchedulePreview } from './types';

// Shared by CampaignSchedulesTab and SalesforceCampaignSchedulesModal so both compute candidates from
// the same rows exactly once, instead of duplicating this chain in two places.
export function useCampaignScheduleImportCandidates(
  preview: CampaignSchedulePreview | undefined,
  brandSchedules: Array<BrandSchedule>,
) {
  const parentRows = useMemo(() => preview?.rows ?? [], [preview]);
  // availability/online_purchase aren't shown as their own row in the Salesforce Campaign Schedules
  // table (they're not something Salesforce sent), but still need to be created as part of the import.
  const importRows = useMemo(() => [...(preview?.derivedSchedules ?? []), ...parentRows], [preview, parentRows]);
  const { candidates, warnings: candidateWarnings } = useMemo(
    () => buildImportCandidates(importRows, brandSchedules),
    [importRows, brandSchedules],
  );

  return { parentRows, candidates, candidateWarnings };
}
